export const LOGIN_CLEAR_PASSWORD = 'LOGIN_CLEAR_PASSWORD'
export const LOGIN_CLEAR_VERIF_CODE = 'LOGIN_CLEAR_VERIF_CODE'
export const LOGIN_UPDATE = 'LOGIN_UPDATE'
export const LOGIN_TIME_SMS = 'LOGIN_TIME_SMS'
export const LOGIN_REFRESH_CAPTCHA = 'LOGIN_REFRESH_CAPTCHA'
export const LOGIN_CLEAR_STATE = 'LOGIN_CLEAR_STATE'

export const SET_WECHAT_JS_READY = 'SET_WECHAT_JS_READY'
export const SET_QINIU_CONFIG = 'SET_QINIU_CONFIG'

export const SET_DIALOG_HTML = 'SET_DIALOG_HTML'
export const SET_NAV_TITLE = 'SET_NAV_TITLE'
export const SET_PAGINATION = 'SET_PAGINATION'
export const SET_LOADING = 'SET_LOADING'
export const SET_TEAM_INFO = 'SET_TEAM_INFO'
export const SET_USER = 'SET_USER'
export const SET_USER_SUPPORT = 'SET_USER_SUPPORT'
export const SET_NOTIFICATION_OPEN = 'SET_NOTIFICATION_OPEN'
export const SET_NOTIFICATION_LOADING = 'SET_NOTIFICATION_LOADING'
export const SET_WECHAT_JS_CONFIG = 'SET_WECHAT_JS_CONFIG'

export const SET_LOADED_OF_CONTACT_LIST = 'SET_LOADED_OF_CONTACT_LIST'
export const SET_LOADED_OF_FORM_LIST = 'SET_LOADED_OF_FORM_LIST'
export const SET_LOADED_OF_SIGNUP_LIST = 'SET_LOADED_OF_SIGNUP_LIST'
export const SET_LOADED_OF_CF_LIST = 'SET_LOADED_OF_CF_LIST'
export const SET_LOADED_ID_OF_CONTACT_CONTACT_FORMFILL = 'SET_LOADED_ID_OF_CONTACT_CONTACT_FORMFILL'
export const SET_LOADED_ID_OF_CONTACT_CONTACT_SIGNUP = 'SET_LOADED_ID_OF_CONTACT_CONTACT_SIGNUP'
export const SET_LOADED_ID_OF_CONTACT_CONTACT_DONATE = 'SET_LOADED_ID_OF_CONTACT_CONTACT_DONATE'
export const SET_LOADED_ID_OF_CONTACT_TAGGED_LIST = 'SET_LOADED_ID_OF_CONTACT_TAGGED_LIST'
export const SET_LOADED_ID_OF_FORM_FEEDBACK = 'SET_LOADED_ID_OF_FORM_FEEDBACK'
export const SET_LOADED_ID_OF_CF_FEEDBACK = 'SET_LOADED_ID_OF_CF_FEEDBACK'

export const TRANSITION_SET_BACK = 'TRANSITION_SET_BACK'

export const DASHBOARD_SET_STAT = 'DASHBOARD_SET_STAT'
export const DASHBOARD_SET_NEWS = 'DASHBOARD_SET_NEWS'

export const CONTACT_SET_LIST = 'CONTACT_SET_LIST'
export const CONTACT_SET_CONTACT = 'CONTACT_SET_CONTACT'
export const CONTACT_SET_ORG = 'CONTACT_SET_ORG'
export const CONTACT_SET_TAGGED_LIST = 'CONTACT_SET_TAGGED_LIST'
export const CONTACT_SET_CONTACT_FORMFILLS = 'CONTACT_SET_CONTACT_FORMFILLS'
export const CONTACT_SET_CONTACT_SIGNUPS = 'CONTACT_SET_CONTACT_SIGNUPS'
export const CONTACT_SET_CONTACT_DONATES = 'CONTACT_SET_CONTACT_DONATES'
export const CONTACT_SET_CONTACT_DONATE_STAT = 'CONTACT_SET_CONTACT_DONATE_STAT'
export const CONTACT_SET_CONTACT_REMARKS = 'CONTACT_SET_CONTACT_REMARKS'
export const CONTACT_SET_CONTACT_ATTACHMENTS = 'CONTACT_SET_CONTACT_ATTACHMENTS'

export const FORM_SET_LIST = 'FORM_SET_LIST'
export const FORM_SET_FEEDBACK_LIST = 'FORM_SET_FEEDBACK_LIST'
export const FORM_SET_FEEDBACK_SUMMARY = 'FORM_SET_FEEDBACK_SUMMARY'
export const FORM_SET_FEEDBACK_DETAIL = 'FORM_SET_FEEDBACK_DETAIL'
export const FORM_SET_FEEDBACK_PRIVATE_FORM = 'FORM_SET_FEEDBACK_PRIVATE_FORM'
export const FORM_SET_FEEDBACK_PRIVATE_FORM_DETAIL = 'FORM_SET_FEEDBACK_PRIVATE_FORM_DETAIL'

export const CF_SET_LIST = 'CF_SET_LIST'
export const CF_SET_FEEDBACK_LIST = 'CF_SET_FEEDBACK_LIST'
export const CF_SET_FEEDBACK_SUMMARY = 'CF_SET_FEEDBACK_SUMMARY'
export const CF_SET_FEEDBACK_DETAIL = 'CF_SET_FEEDBACK_DETAIL'

export const SET_SEARCH_RESULT = 'SET_SEARCH_RESULT'
export const CLEAR_SEARCH_RESULT = 'CLEAR_SEARCH_RESULT'
export const SET_SHARE = 'SET_SHARE'

export const GEETEST_SET_CAPTCHA_OBJ_INITED = 'GEETEST_SET_CAPTCHA_OBJ_INITED'
export const GEETEST_SET_VALIDATE = 'GEETEST_SET_VALIDATE'

export const ACTIVITY_SET_LIST = 'ACTIVITY_SET_LIST'
export const ACTIVITY_SET_DETAIL = 'ACTIVITY_SET_DETAIL'
export const ACTIVITY_SET_COUNT = 'ACTIVITY_SET_COUNT'
export const ACTIVITY_SET_SIGN_UP = 'ACTIVITY_SET_SIGN_UP'
export const ACTIVITY_SET_SIGN_UPS = 'ACTIVITY_SET_SIGN_UPS'
export const ACTIVITY_SET_FEEDBACK = 'ACTIVITY_SET_FEEDBACK'
export const SET_LOADED_OF_ACTIVITY_LIST = 'SET_LOADED_OF_ACTIVITY_LIST'
export const ACTIVITY_SET_FEEDBACK_SIGNUPLIST = 'ACTIVITY_SET_FEEDBACK_SIGNUPLIST'
export const SET_LOADED_ID_OF_ACTIVITY_FEEDBACK = 'SET_LOADED_ID_OF_ACTIVITY_FEEDBACK'
export const ACTIVITY_SET_FEEDBACK_SIGNLOADING = 'ACTIVITY_SET_FEEDBACK_SIGNLOADING'
export const ACTIVITY_SET_FEEDBACK_SIGNLOADED = 'ACTIVITY_SET_FEEDBACK_SIGNLOADED'
export const ACTIVITY_SET_FEEDBACK_DETAIL = 'ACTIVITY_SET_FEEDBACK_DETAIL'
export const ACTIVITY_SET_SIGN_UP_TICKETS = 'ACTIVITY_SET_SIGN_UP_TICKETS'
export const ACTIVITY_SET_SIGN_UP_SESSION_TIME = 'ACTIVITY_SET_SIGN_UP_SESSION_TIME'
export const ACTIVITY_SET_SIGN_UP_FORM_DATA = 'ACTIVITY_SET_SIGN_UP_FORM_DATA'
export const ACTIVITY_RESET_SIGN_UP = 'ACTIVITY_RESET_SIGN_UP'
export const ACTIVITY_RESET_DETAIL = 'ACTIVITY_RESET_DETAIL'
export const ACTIVITY_SET_SIGNIN_STATISTICS = 'ACTIVITY_SET_SIGNIN_STATISTICS'
export const ACTIVITY_SET_SELECTED_SESSION_TIME_ID = 'ACTIVITY_SET_SELECTED_SESSION_TIME_ID'
export const ACTIVITY_RESET_FEEDBACK = 'ACTIVITY_RESET_FEEDBACK'
export const ACTIVITY_SET_SCAN_QRCODE = 'ACTIVITY_SET_SCAN_QRCODE'
export const ACTIVITY_SET_SCAN_QRCODE_MODAL_VISIBLE = 'ACTIVITY_SET_SCAN_QRCODE_MODAL_VISIBLE'

export const SET_REGISTER_STATUS = 'SET_REGISTER_STATUS'
export const DASHBOARD_SET_TEAM_INFO = 'DASHBOARD_SET_TEAM_INFO'

export const REGISTER_TEAM_COUNT = 'REGISTER_TEAM_COUNT'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js